import { AiFillLinkedin, AiFillGithub, AiFillYoutube, AiOutlineTwitter } from "react-icons/ai";

const Socials = () => {
    return (
        <div className="mt-10 w-[200px]">
            <div className="flex justify-around">
                <a href="https://github.com/peterjohnson1000" className="cursor-pointer" target="_blank"><AiFillGithub className="text-3xl"/></a>
                <a href="https://www.linkedin.com/in/peterjohns0n/" className="cursor-pointer" target="_blank"><AiFillLinkedin className="text-3xl"/></a>
                <a href="https://twitter.com/peterjohnson131" className="cursor-pointer" target="_blank"><AiOutlineTwitter className="text-3xl"/></a>
                <a href="https://www.youtube.com/peterin" className="cursor-pointer" target="_blank"><AiFillYoutube className="text-3xl"/></a>
            </div>
        </div>
    );
};

export default Socials;